import { TextCodes } from '@api/types/translation/TextCodes';
import { CustomTextField, useBuyersCertificateCreateContext } from '@components';
import { Cancel, CheckCircle } from '@mui/icons-material';
import { CircularProgress, InputAdornment } from '@mui/material';
import { colors } from '@themes/colors';
import { t } from '@translations';

type BuyersCertificateSerialNumberProps = {
  isEditEnabled?: boolean;
};

export const BuyersCertificateSerialNumber = ({
  isEditEnabled,
}: BuyersCertificateSerialNumberProps) => {
  const { form, isSerialNoValid, serialNumberOnChange, getSerialNoStatus, SerialNoRequestStatus } =
    useBuyersCertificateCreateContext();

  return (
    <CustomTextField
      fullWidth
      label={t(TextCodes.Warranty.Block.SerialNumber, { example: '' })}
      variant='outlined'
      type='text'
      sx={{ mt: 5 }}
      required={true}
      {...form.register('serialNumber', {
        required: true,
        onChange: (e) => serialNumberOnChange(e.target.value),
      })}
      error={isSerialNoValid === false || !!form.formState.errors.serialNumber}
      helperText={
        isSerialNoValid === false ? t(TextCodes.BuyersCertificate.Block.SerialNumberInvalid) : null
      }
      InputProps={{
        readOnly: !isEditEnabled,
        endAdornment: (
          <InputAdornment position='end'>
            {getSerialNoStatus() === SerialNoRequestStatus.Pending ? (
              <CircularProgress size={20} sx={{ mr: 1 }} />
            ) : getSerialNoStatus() === SerialNoRequestStatus.Valid ? (
              <CheckCircle sx={{ color: colors.primary.complimentaryGreen, mr: 1 }} />
            ) : getSerialNoStatus() === SerialNoRequestStatus.Invalid ? (
              <Cancel sx={{ color: colors.error.main, mr: 1 }} />
            ) : null}
          </InputAdornment>
        ),
      }}
    />
  );
};
